<template>
    <div>
      <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <div v-else>
        <v-row>
          <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
            <div class="title_page ma-3">
              <h4 class="breadcrumb_title_page">ประวัติการชำระเงิน</h4>
              <v-breadcrumbs :items="sub_menu">
                <template v-slot:divider>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-breadcrumbs>
            </div>
          </v-col>
        </v-row>
  
        <v-row class="mb-0">
            <v-col cols="12">
                 <v-card class="mx-auto input-radius bg-green"  >
                    <v-list-item three-line class="py-4">
                        <v-list-item-content>
                            <v-row>
                                <v-col cols="12" lg="6">
                                    <div class="bold text-white font-22 font-bold ">
                                        ยอดเงินชำระ
                                    </div>
                                </v-col>
                            </v-row>
                          
                            <v-list-item-title class="text-center mb-1 text-white font-bold-36">
                                {{formatPrice(total)}} <span class="font-18 font-bold"> บาท </span>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-center font-18 font-bold text-white">วันครบกำหนด {{data_list[0].due_date}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
  
                </v-card>
            </v-col>
  
            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <h2 class="ml-3 mb-2">รายการ</h2>
                <v-card class="input-radius pa-2" v-for="item in data_list[0].order" :key="item.id">
                  <!-- <v-card-title class="font-bold py-6">รายการ</v-card-title> -->
                  <v-card-text>
  
                    <v-row>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" >
                          <div class="text_title">
                              วันที่สั่งซื้อ : {{item.created_at}}
                          </div>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                          <div class="text_title">
                              ยอดการสั่งซื้อ : {{formatPrice(item.total)}} บาท
                          </div>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                          <div class="text_title">
                              ผู้รับ : {{item.name}} ({{item.telephone}})
                          </div>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                          <div class="text_title">
                              ที่อยู่ : {{item.address}}
                          </div>
                        </v-col>
                        <v-col cols="12 boder-D6BFAF">
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left" width="40%">
                                    <div class="font-16">รายการสินค้า</div> 
                                  </th>
                                  <th class="text-left" width="20%">
                                    <div class="font-16">ราคาต่อหน่วย</div> 
                                  </th>
                                  <th class="text-left"  width="20%">
                                    <div class="font-16">จำนวน</div>
                                  </th>
                                  <th class="text-left" width="20%">
                                    <div class="font-16">ราคารวม</div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody >
                                <tr v-for="sub in item.list" :key="sub">
                                  <td class="flex-center table-hight py-2">
                                    <v-img :lazy-src="refund" :src="refund" max-height="80px" max-width="80px"></v-img> 
                                    <div class=""> {{ sub.name }} </div>
                                  </td>
                                  <td class="table-hight">{{ formatPrice(sub.cost) }}</td>
                                  <td class="table-hight">{{ formatPrice(sub.quantity) }}</td>
                                  <td class="table-hight">{{ formatPrice(sub.total) }}</td>
                                </tr>
                                <tr>
                                  <td colspan="2" class="emply-boder"></td>
                                  <td class="emply-boder">ค่าจัดส่ง</td>
                                  <td class="emply-boder">{{formatPrice(item.delivery_price)}}</td>
                                </tr>
                                <tr>
                                  <td colspan="2"></td>
                                  <td>รวม</td>
                                  <td>{{formatPrice(parseFloat(item.total) + parseFloat(item.delivery_price))}}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-col>
                      </v-row>
                  </v-card-text>
                </v-card>
  
            </v-col>
        </v-row>
      </div>
    </div>
  </template>
  
  <script>
  import cancel_order from "@/assets/arin_assets/cancel_order.png";
  import refund from "@/assets/arin_assets/refund.png";
  import bill_v2 from "@/assets/arin_assets/bill_v2.png";
   import { HTTP_ARIN } from "@/axios_arin";
  import { formatPrice } from "@/js/handler";
  
  export default {
    inject: {
      theme: {
        default: {
          isDark: false,
        },
      },
    },
    name: "Pos_debt_balance_list",
    data() {
      return {
        img_cancel_order: cancel_order,
        refund: refund,
        bill_v2: bill_v2,
        dialog_cancel_order: false,
        loading_page: false,
        panel: -1,
        disabled: false,
        footer_Props: {
          'items-per-page-text': 'รายการต่อหน้า'
        },
        sub_menu: [
          {
            text: 'ระบบ POS',
            disabled: false,
          },
          {
            text: 'ออกใบสั่งซื้อ',
            disabled: false,
          },
          {
            text: 'ยอดหนี้ของฉัน',
            disabled: false,
          },
          {
            text: 'ประวัติการชำระเงิน',
            disabled: false,
          },
          {
            text: 'ธันวาคม 2022',
            disabled: false,
            href: '#',
          },
        ],
        data_list: [
          {
            id: 1,
            product_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
            price: 120.00,
            qty: 1,
            total: 120.00,
          },
          {
            id: 2,
            product_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 2000 ML. **ฝาฟ้า 65.-',
            price: 50.00,
            qty: 3,
            total: 150.00,
          },
        ],
        total: 0
      }
    },
    methods: {
      formatPrice(number){
        return formatPrice(number)
      },
      link(link) {
        window.location.href = link;
      },
      cancel_order() {
        this.dialog_cancel_order = true;
      },
       getDetail(){
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        let start_date = this.$route.query.start_date
        HTTP_ARIN.get('/credit/history/pay/billing/'+start_date, config).then((res) => {
            if (res.data.successful === true) {
            this.data_list = res.data.detail
            this.total = res.data.total
            this.loading_page = false;
            }
        })
        
       },
    },
    mounted(){
      this.getDetail()
    }
  }
  </script>
  
  <style scoped>
  /* .progress-bar {
  position: relative;
  height: 20px;
  width: 100%;
  } */
  .emply-boder
  {
    border-color: #ffffff !important;
  }
  
  .table-hight
  {
    height: auto !important;
  }

    .boder-D6BFAF
    {
    border: #D6BFAF solid;
    border-radius: 10px;
    }

  
  .text_title {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
  }
  .line {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  }
  
  .number {
  position: absolute;
  top: -20px;
  right: 0;
  z-index: 2;
  }
  
    .color-green
    {
        color: #88B358;
    }
  
    .font-bold-36 {
        font-size: 36px;
        font-weight: bold; 
    }
    
    .text-white {
       color: #FFF !important;
    }
  
    .font-16 {
        font-size: 16px;
    }
    .font-18 {
        font-size: 18px;
    }
  
    .font-22 {
        font-size: 22px;
    }
  
  
    .font-bold {
        font-weight: bold;
    }
    .input-radius {
        border-radius: 10px;
    }
  
    .btn-red-icon {
        color: #EC6162;
        background-color: white;
        font-size: 14px;
        font-weight: bold;
    }
  
    .bg-red {
        background-color: #EC6162
    }

    .bg-green {
        background-color: #88B358
    }
  
    .header_title {
        font-weight: 600;
        font-size: 20px;
        color: #616A6B;
    }
    
    .font_mobile {
        font-size: 14px !important;
    }
    
    .grid_three {
        display: flex;
        justify-content: space-between;
    }
  
    .flex-center {
        display: flex;
        align-items: center;
    }
    
    .tag_arin_magnify {
        border: 1px solid #FEA06C;
        color: #FEA06C;
        font-weight: 500;
        font-size: 16px;
        border-radius: 10px;
        background-color: #FFFFFF;
    }
    
    .preview {
        border-radius: 10px;
        margin: auto;
    }
    
    .btn_pay {
        font-size: 16px;
        color: #FFF;
        background: linear-gradient(90deg, #A82B2C 0%, rgba(136, 179, 88, 0) 100%), #EC6162 !important;
        border-radius: 10px;
        width: 50%;
    }
    
    .btn_add_data_submit {
        font-size: 16px;
        color: #FFF;
        /* background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important; */
        border-radius: 10px;
        width: 15%;
    }
  
  @media only screen and (min-width: 0px)AND (max-width: 361px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #A82B2C 0%, rgba(136, 179, 88, 0) 100%), #EC6162 !important;
      border-radius: 10px;
      width: 100%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 100%;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #A82B2C 0%, rgba(136, 179, 88, 0) 100%), #EC6162 !important;
      border-radius: 10px;
      width: 100%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 601px) AND (max-width: 960px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #A82B2C 0%, rgba(136, 179, 88, 0) 100%), #EC6162 !important;
      border-radius: 10px;
      width: 50%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 961px) AND (max-width: 1264px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #A82B2C 0%, rgba(136, 179, 88, 0) 100%), #EC6162 !important;
      border-radius: 10px;
      width: auto;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 1265px) AND (max-width: 1904px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #A82B2C 0%, rgba(136, 179, 88, 0) 100%), #EC6162 !important;
      border-radius: 10px;
      width: auto;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 25%;
    }
  }
  
  </style>
  